import React from "react";
import { Link } from "react-router-dom";

export default function TermsPage() {
  return (
    <div style={{
      minHeight: "100vh",
      background: "#f9fafb",
      padding: "40px 24px 60px",
      boxSizing: "border-box"
    }}>
      <div style={{ maxWidth: 720, margin: "0 auto" }}>
        <Link
          to="/signup"
          style={{
            display: "inline-block",
            marginBottom: 32,
            color: "#3399FF",
            fontWeight: 600,
            textDecoration: "none",
            fontSize: 14
          }}
        >
          ← Terug naar aanmelden
        </Link>
        <h1 style={{
          margin: "0 0 8px 0",
          fontSize: 28,
          fontWeight: 700,
          color: "#111827"
        }}>
          Algemene voorwaarden
        </h1>
        <p style={{ margin: "0 0 32px 0", fontSize: 14, color: "#6b7280" }}>
          Laatst bijgewerkt: februari 2025
        </p>

        <div style={{
          background: "#fff",
          border: "1px solid #e5e7eb",
          borderRadius: 16,
          padding: "32px 28px",
          fontSize: 15,
          lineHeight: 1.7,
          color: "#374151"
        }}>
          <h2 style={{ margin: "0 0 16px 0", fontSize: 18, fontWeight: 700, color: "#111827" }}>1. Aanbieder</h2>
          <p style={{ margin: "0 0 24px 0" }}>
            Deze algemene voorwaarden zijn van toepassing op het gebruik van de diensten en de website van Slimmer Af.
          </p>

          <h2 style={{ margin: "0 0 16px 0", fontSize: 18, fontWeight: 700, color: "#111827" }}>2. Intellectueel eigendom en rechten</h2>
          <p style={{ margin: "0 0 24px 0" }}>
            Alle rechten met betrekking tot de website, de diensten, de inhoud (waaronder teksten, afbeeldingen, logo’s, lay-out en software) en alle daarop betrekking hebbende merken en kennisdomeinen berusten uitsluitend bij <strong>Slimmer Af</strong>. Niets uit deze voorwaarden of het gebruik van de diensten mag worden uitgelegd als een overdracht van enig recht aan de gebruiker. Alle rechten voorbehouden.
          </p>

          <h2 style={{ margin: "0 0 16px 0", fontSize: 18, fontWeight: 700, color: "#111827" }}>3. Geen rechten aan de informatie</h2>
          <p style={{ margin: "0 0 24px 0" }}>
            De informatie die Slimmer Af aanbiedt (onder meer berekeningen, adviezen, grafieken en teksten) is uitsluitend bedoeld als algemene informatie en voor persoonlijk gebruik. <strong>Er kunnen geen rechten worden ontleend aan de op de website of in de diensten getoonde informatie.</strong> De informatie is niet bedoeld als professioneel financieel, fiscaal of juridisch advies. Voor beslissingen over je studieschuld of financiën raadpleeg waar nodig een deskundige. Slimmer Af aanvaardt geen aansprakelijkheid voor handelingen die je verricht op basis van de verstrekte informatie.
          </p>

          <h2 style={{ margin: "0 0 16px 0", fontSize: 18, fontWeight: 700, color: "#111827" }}>4. Gebruik van de dienst</h2>
          <p style={{ margin: "0 0 24px 0" }}>
            Je gebruikt de dienst voor persoonlijke, niet-commerciële doeleinden. Je deelt geen inloggegevens met derden en houdt je aan de geldende wet- en regelgeving.
          </p>

          <h2 style={{ margin: "0 0 16px 0", fontSize: 18, fontWeight: 700, color: "#111827" }}>5. Wijzigingen</h2>
          <p style={{ margin: "0 0 24px 0" }}>
            Slimmer Af kan deze algemene voorwaarden wijzigen. De actuele versie staat op deze pagina. Door de dienst te blijven gebruiken, ga je akkoord met de dan geldende voorwaarden.
          </p>

          <h2 style={{ margin: "0 0 16px 0", fontSize: 18, fontWeight: 700, color: "#111827" }}>6. Toepasselijk recht</h2>
          <p style={{ margin: 0 }}>
            Op deze voorwaarden is Nederlands recht van toepassing.
          </p>
        </div>

        <p style={{ marginTop: 24, fontSize: 14, color: "#6b7280", textAlign: "center" }}>
          Vragen? Neem contact met ons op via de website.
        </p>
      </div>
    </div>
  );
}
